import { useState } from 'react';

import ResetIcon from 'icons/reset.svg?react';
import { toast } from 'material-react-toastify';

import { ConfirmationPopup } from '@/components/Popup/ConfirmationPopup/ConfirmationPopup';
import Button from '@/components/shared/Button/Button';
import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { DEFAULT_PASSWORD } from '@/lib/constants';
import { getAuthToken } from '@/lib/firebase/token';

import styles from './ResetPassword.module.scss';

interface ResetPasswordProps {
  userId: string;
}

const ResetPassword = ({ userId }: ResetPasswordProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleResetPassword = async () => {
    const token = await getAuthToken();
    try {
      await hubApi.updateUserPasswordHub(
        userId,
        { password: DEFAULT_PASSWORD },
        withAuthHeader(token),
      );
      setIsPopupOpen(false);
      toast.success(`User's password was reset successfully`);
    } catch (error) {
      console.error('Error resetting password:', error);
    }
  };

  return (
    <div>
      <Button
        onClick={() => setIsPopupOpen(true)}
        prefixIcon={<img src="/icons/reset.svg" alt="Reset Password" />}
        label="Reset Password"
        variant="transparent"
        size="s"
        className="w-[168px] font-semibold"
      />

      <ConfirmationPopup
        isOpen={isPopupOpen}
        title="Reset Password"
        description={`Are you sure you want to reset the password for this user?\nThe password will be automatically changed to addmile123.`}
        handleConfirm={handleResetPassword}
        closePopup={() => setIsPopupOpen(false)}
        variant="warning"
        confirmText="Yes, Reset"
        popupIcon={
          <div className={styles.resetIcon}>
            <ResetIcon className="text-white-100" width={24} height={24} />
          </div>
        }
      />
    </div>
  );
};

export default ResetPassword;
